<template>
  <div>
    <transition
      name="custom-classes-transition"
      enter-active-class="fade-in"
      leave-active-class="fade-out"
    >
      <div v-if="sidePanelStates.show" @click="outClick()" class="outClick"></div>
    </transition>
    <transition
      name="custom-classes-transition"
      enter-active-class="slide-in-right"
      leave-active-class="slide-out-right"
    >
      <div v-if="sidePanelStates.show" class="sidepanel evidenzia curvatura_tendina">
        <Carrello></Carrello>
      </div>
    </transition>
  </div>
</template>
<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import { mapState } from "vuex";
import Carrello from "@/components/Carrello";
export default {
  name: "sidePanel",
  components: {
    Carrello
  },
  directives: {},
  data() {
    return {
      //VARIABILI AMBIENTE
    };
  },
  computed: {
    ...mapState(["sidePanelStates"])
  },
  methods: {
    outClick() {
      this.close();
    },
    close() {
      this.$router.replace(this.$router.currentRoute.path);
    }
  },
  mounted() {
    var id = this.$route.query.checkout;
    if (id !== undefined) {
      this.$store
        .dispatch("ordineStates/getOrder", id)
        .then(response => {
          console.log("Ordine Fast CheckOut Caricato");
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  beforeDestroy(){
    //INIZIALIZZO I MODULI VUEX ORDINE E LISTINO
    this.$store.commit("ordineStates/resetOrder");
    this.$store.commit("listinoStates/initModule");
  }
};
</script>

<style scoped >
.outClick {
  background-color: black;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99997;
  height: 100%;
  width: 100%;
  opacity: 0.5;
}

.sidepanel {
  position: absolute;
  padding: 0.2vh;
  top: 0px;
  right: 0px;
  width: 35vw;
  height: 100%;
  background-color: white;
  -webkit-box-shadow: -1px 3px 5px 2px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: -1px 3px 5px 2px rgba(0, 0, 0, 0.3);
  box-shadow: -1px 3px 5px 2px rgba(0, 0, 0, 0.3);
}

.slide-in-right {
  -webkit-animation: slide-in-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: slide-in-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(40vw);
    transform: translateX(40vw);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(40vw);
    transform: translateX(40vw);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.slide-out-right {
  -webkit-animation: slide-out-right 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53)
    both;
  animation: slide-out-right 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

@-webkit-keyframes slide-out-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 1;
  }
}
@keyframes slide-out-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 1;
  }
}

.fade-in {
  -webkit-animation: fade-in 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.5;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.5;
  }
}

.fade-out {
  -webkit-animation: fade-out 0.3s ease-out both;
  animation: fade-out 0.3s ease-out both;
}

@-webkit-keyframes fade-out {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fade-out {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
</style>
